import React from 'react';

export default class ScaleControls extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      viewport: props.viewport,
      scale: props.viewport.scale
    };
    this.state.viewport.addEventListener('update-scale', (scale) => {
      this.setState({
        scale: scale
      });
    });
  }

  render() {
    let viewport = this.state.viewport;
    let scale = this.state.scale;

    return (
      <div id="scaleWrapper">
        <div className="ui mini left icon input">
          <input type="number" className="scale" value={Math.round(scale * 100, 2)} onChange={e => viewport.setScale(e.target.value * 0.01)} />
          <i className="zoom icon" />
        </div>
        <div className="ui mini icon buttons">
          <button className="ui mini button" data-content="По высоте" onClick={() => viewport.autoScale('fit width')}>
            <i className="resize horizontal icon" />
          </button>
          <button className="ui mini button" data-content="По ширине" onClick={() => viewport.autoScale('fit height')}>
            <i className="resize vertical icon" />
          </button>
          <button className="ui mini button" data-content="Оригинальный размер" onClick={() => viewport.autoScale('100%')}>
            <i className="maximize icon" />
          </button>
        </div>
      </div>
    );
  }
}
